var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Ocorreu um erro ao deletar o "),_c('b',[_vm._v("Anexo")]),_vm._v(". ")])}]

export { render, staticRenderFns }